import script from "./ingredients-without-dv-section.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredients-without-dv-section.vue?vue&type=script&setup=true&lang=js"

import "./ingredients-without-dv-section.vue?vue&type=style&index=0&id=04508fef&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04508fef"]])

export default __exports__